module.exports = __webpack_public_path__ + "img/features_overview.7534c0f3.svg";